// import { useState } from "react"
// import { useForm } from "react-hook-form"
// import { useNavigate } from "react-router-dom"
// import { Button } from "../components/ui/button"
// import { Eye, EyeOff, LogIn, Lock, Mail, Sparkles } from "lucide-react"
// import { Input } from "../components/ui/input"
// import { Label } from "../components/ui/label"
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
//   CardFooter,
// } from "../components/ui/card"
// import { useToast } from "../hooks/useToast"
// import { useAuth } from "../contexts/AuthContext"

// type LoginForm = {
//   email: string
//   password: string
// }

// export function Login() {
//   const [loading, setLoading] = useState(false)
//   const { toast } = useToast()
//   const { login } = useAuth()
//   const navigate = useNavigate()
//   const { register, handleSubmit } = useForm<LoginForm>()
//   const [showPassword, setShowPassword] = useState(false)

//   console.log("Login.tsx: Component mounted/rendered");

//   const onSubmit = async (data: LoginForm) => {
//     try {
//       console.log("Login.tsx: Form submission started");
//       console.log("Login.tsx: Form data received:", { email: data.email, password: "***" });

//       setLoading(true)
//       console.log("Login.tsx: Loading state set to true");

//       console.log("Login.tsx: Calling login from AuthContext");
//       await login(data.email, data.password);

//       console.log("Login.tsx: Login successful, showing success toast");
//       toast({
//         title: "Success",
//         description: "Logged in successfully",
//       })

//       console.log("Login.tsx: Navigating to home page");
//       navigate("/dashboard");
//       console.log("Login.tsx: Navigation completed");

//     } catch (error) {
//       console.error("Login.tsx: Login error occurred:", error)
//       console.error("Login.tsx: Error message:", error?.message)

//       console.log("Login.tsx: Showing error toast");
//       toast({
//         title: "Error",
//         description: "Invalid Credentials",
//       })
//     } finally {
//       console.log("Login.tsx: Setting loading state to false");
//       setLoading(false)
//     }
//   }

//   return (
//     <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
//       {/* Background decorative elements */}
//       <div className="absolute inset-0 z-0">
//         {/* Animated floating shapes */}
//         <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-r from-blue-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
//         <div className="absolute bottom-10 right-10 w-72 h-72 bg-gradient-to-l from-purple-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
//         <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-gradient-to-r from-indigo-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-60 animate-pulse delay-500"></div>

//         {/* Grid pattern */}
//         <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik02MCAwSDB2NjBoNjBWMHpNMCAwaDYwdjYwSDBWMHoiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4wMSkiLz48L2c+PC9zdmc+')] opacity-20"></div>
//       </div>

//       {/* Sparkles decoration */}
//       <div className="absolute top-6 right-6 text-blue-400 dark:text-blue-300 opacity-60">
//         <Sparkles size={24} className="animate-spin-slow" />
//       </div>
//       <div className="absolute bottom-6 left-6 text-purple-400 dark:text-purple-300 opacity-60">
//         <Sparkles size={20} className="animate-spin-slow" />
//       </div>

//       {/* Login Card */}
//       <div className="relative z-10 w-full max-w-md mx-4">
//         <Card className="w-full backdrop-blur-sm bg-white/90 dark:bg-gray-800/90 border-gray-200 dark:border-gray-700 shadow-2xl shadow-blue-500/10 dark:shadow-blue-500/5 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20">
//           <CardHeader className="text-center pb-6">
//             <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg">
//               <Lock className="h-8 w-8 text-white" />
//             </div>
//             <CardTitle className="text-2xl font-bold text-gray-800 dark:text-white">
//               Welcome back
//             </CardTitle>
//             <CardDescription className="text-gray-600 dark:text-gray-300">
//               Enter your credentials to access your account
//             </CardDescription>
//           </CardHeader>

//           <CardContent>
//             <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
//               <div className="space-y-3">
//                 <Label htmlFor="email" className="text-gray-700 dark:text-gray-300 font-medium">
//                   Email Address
//                 </Label>
//                 <div className="relative">
//                   <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
//                   <Input
//                     id="email"
//                     type="email"
//                     placeholder="you@example.com"
//                     className="pl-10 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400 transition-colors"
//                     {...register("email", { required: true })}
//                   />
//                 </div>
//               </div>

//               <div className="space-y-3">
//                 <div className="flex justify-between items-center">
//                   <Label htmlFor="password" className="text-gray-700 dark:text-gray-300 font-medium">
//                     Password
//                   </Label>
//                   <p
//                     onClick={() => navigate("/forgot-password")}
//                     className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline cursor-pointer transition-colors"
//                   >
//                     Forgot Password?
//                   </p>
//                 </div>
//                 <div className="relative">
//                   <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
//                   <Input
//                     id="password"
//                     type={showPassword ? "text" : "password"}
//                     placeholder="Enter your password"
//                     className="pl-10 pr-12 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400 transition-colors"
//                     {...register("password", { required: true })}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     className="absolute right-3 top-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
//                   >
//                     {showPassword ? (
//                       <EyeOff size={20} className="stroke-current" />
//                     ) : (
//                       <Eye size={20} className="stroke-current" />
//                     )}
//                   </button>
//                 </div>
//               </div>

//               <Button
//                 type="submit"
//                 className="w-full h-12 mt-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold shadow-lg shadow-blue-500/25 dark:shadow-blue-500/15 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/35 disabled:opacity-50 disabled:cursor-not-allowed"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <div className="flex items-center justify-center">
//                     <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
//                     <span className="ml-2">Signing in...</span>
//                   </div>
//                 ) : (
//                   <>
//                     <LogIn className="mr-2 h-5 w-5" />
//                     Sign In
//                   </>
//                 )}
//               </Button>
//               <Button
//                 type="button"
//                 onClick={() => navigate("/")}
//                 className="w-full h-12 mt-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-semibold shadow-md transition-all duration-300"
//               >
//                 ← Back to Home
//               </Button>
//             </form>
//           </CardContent>

//           <CardFooter className="flex justify-center pt-6 border-t border-gray-100 dark:border-gray-700">
//             <p className="text-gray-600 dark:text-gray-400 text-sm">
//               Don't have an account?{" "}
//               <Button
//                 variant="link"
//                 className="p-0 h-auto font-semibold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
//                 onClick={() => {
//                   console.log("Login.tsx: Navigate to register button clicked");
//                   navigate("/register")
//                 }}
//               >
//                 Sign up now
//               </Button>
//             </p>
//           </CardFooter>
//         </Card>

//         {/* Additional Info */}
//         <div className="mt-8 text-center">
//           <p className="text-sm text-gray-500 dark:text-gray-400 opacity-75">
//             Secure login with end-to-end encryption
//           </p>
//         </div>
//       </div>

//       {/* Footer note */}
//       <div className="absolute bottom-4 left-0 right-0 text-center">
//         <p className="text-xs text-gray-400 dark:text-gray-500">
//           Protected by advanced security protocols • © {new Date().getFullYear()}
//         </p>
//       </div>
//     </div>
//   )
// }



import { useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Eye, EyeOff, LogIn, Lock, Mail, Sparkles, Building2, Check, ArrowLeft } from "lucide-react"
import { Input } from "../components/ui/input"
import { Label } from "../components/ui/label"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter,
} from "../components/ui/card"
import { useToast } from "../hooks/useToast"
import { useAuth } from "../contexts/AuthContext"
import { getOrganizations } from "../api/auth"

type LoginForm = {
  email: string
  password: string
}

interface Organization {
  head_office_id: string
  company_name: string
  organization: string
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState<"email" | "organizations" | "login">("email")
  const [organizations, setOrganizations] = useState<Organization[]>([])
  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null)
  const [email, setEmail] = useState("")
  const { toast } = useToast()
  const { login } = useAuth()
  const navigate = useNavigate()
  const { register, handleSubmit } = useForm<LoginForm>()
  const [showPassword, setShowPassword] = useState(false)

  console.log("Login.tsx: Component mounted/rendered");

  // Step 1: Get organizations by email
  const handleGetOrganizations = async (data: LoginForm) => {
    try {
      console.log("Login.tsx: Getting organizations for email:", data.email);
      setLoading(true)
      setEmail(data.email)

      const response = await getOrganizations(data.email)
      console.log("Login.tsx: Organizations response:", response)

      if (response.success && response.organizations && response.organizations.length > 0) {
        setOrganizations(response.organizations)
        
        // If only one organization, auto-select it and go to login
        if (response.organizations.length === 1) {
          const singleOrg = response.organizations[0]
          setSelectedOrg(singleOrg)
          setStep("login")
          toast({
            title: "Success",
            description: `Logged in to ${singleOrg.company_name}`,
          })
        } else {
          // Multiple organizations - show selection screen
          setStep("organizations")
          toast({
            title: "Success",
            description: `Found ${response.organizations.length} organizations. Please select one.`,
          })
        }
      } else {
        toast({
          // title: "Error",
          description: "No organizations found for this email",
          variant: "destructive",
        })
      }
    } catch (error: any) {
      console.error("Login.tsx: Error getting organizations:", error)
      toast({
        // title: "Error",
        description: error.message || "Failed to fetch organizations",
        variant: "destructive",
      })
    } finally {
      setLoading(false)
    }
  }

  // Step 2: Select organization (only shown when multiple organizations exist)
  const handleSelectOrganization = (org: Organization) => {
    setSelectedOrg(org)
    setStep("login")
  }

  // Step 3: Complete login with email, password, and head_office_id
  const handleCompleteLogin = async (data: LoginForm) => {
    if (!selectedOrg) {
      toast({
        // title: "Error",
        description: "Please select an organization first",
        variant: "destructive",
      })
      return
    }

    try {
      console.log("Login.tsx: Completing login with organization:", selectedOrg.head_office_id);
      setLoading(true)

      // Call login with email, password, and head_office_id
      await login(email, data.password, selectedOrg.head_office_id)

      console.log("Login.tsx: Login successful, showing success toast");
      toast({
        title: "Success",
        description: `Logged in to ${selectedOrg.company_name} successfully`,
      })

      console.log("Login.tsx: Navigating to dashboard");
      navigate("/dashboard");
      console.log("Login.tsx: Navigation completed");

    } catch (error: any) {
      console.error("Login.tsx: Login error occurred:", error)
      console.error("Login.tsx: Error message:", error?.message)

      toast({
        // title: "Error",
        description: error.message || "Invalid Credentials",
        variant: "destructive",
      })
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = async (data: LoginForm) => {
    if (step === "email") {
      await handleGetOrganizations(data)
    } else if (step === "login") {
      await handleCompleteLogin(data)
    }
  }

  const handleBackToEmail = () => {
    setStep("email")
    setOrganizations([])
    setSelectedOrg(null)
  }

  const handleBackToOrganizations = () => {
    setStep("organizations")
    setSelectedOrg(null)
  }

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      {/* Background decorative elements */}
      <div className="absolute inset-0 z-0">
        {/* Animated floating shapes */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-r from-blue-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-gradient-to-l from-purple-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-gradient-to-r from-indigo-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-60 animate-pulse delay-500"></div>

        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik02MCAwSDB2NjBoNjBWMHpNMCAwaDYwdjYwSDBWMHoiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4wMSkiLz48L2c+PC9zdmc+')] opacity-20"></div>
      </div>

      {/* Sparkles decoration */}
      <div className="absolute top-6 right-6 text-blue-400 dark:text-blue-300 opacity-60">
        <Sparkles size={24} className="animate-spin-slow" />
      </div>
      <div className="absolute bottom-6 left-6 text-purple-400 dark:text-purple-300 opacity-60">
        <Sparkles size={20} className="animate-spin-slow" />
      </div>

      {/* Login Card */}
      <div className="relative z-10 w-full max-w-md mx-4">
        <Card className="w-full backdrop-blur-sm bg-white/90 dark:bg-gray-800/90 border-gray-200 dark:border-gray-700 shadow-2xl shadow-blue-500/10 dark:shadow-blue-500/5 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20">
          <CardHeader className="text-center pb-6">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg">
              {step === "organizations" ? (
                <Building2 className="h-8 w-8 text-white" />
              ) : (
                <Lock className="h-8 w-8 text-white" />
              )}
            </div>
            <CardTitle className="text-2xl font-bold text-gray-800 dark:text-white">
              {step === "email" && "Welcome back"}
              {step === "organizations" && "Select Organization"}
              {step === "login" && organizations.length === 1 && `Welcome to ${selectedOrg?.company_name}`}
              {step === "login" && organizations.length > 1 && `Login to ${selectedOrg?.company_name}`}
            </CardTitle>
            <CardDescription className="text-gray-600 dark:text-gray-300">
              {step === "email" && "Enter your email to get started"}
              {step === "organizations" && `You have access to ${organizations.length} organizations. Choose one to continue.`}
              {step === "login" && organizations.length === 1 && "Enter your password to access your account"}
              {step === "login" && organizations.length > 1 && "Enter your password to continue"}
            </CardDescription>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              {/* Step 1: Email Input */}
              {step === "email" && (
                <div className="space-y-3">
                  <Label htmlFor="email" className="text-gray-700 dark:text-gray-300 font-medium">
                    Email Address
                  </Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="you@example.com"
                      className="pl-10 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400 transition-colors"
                      {...register("email", { required: true })}
                    />
                  </div>
                </div>
              )}

              {/* Step 2: Organizations List (only shown when multiple organizations) */}
              {step === "organizations" && (
                <div className="space-y-3">
                  <Label className="text-gray-700 dark:text-gray-300 font-medium">
                    Select Your Organization
                  </Label>
                  <div className="space-y-2 max-h-96 overflow-y-auto">
                    {organizations.map((org, index) => (
                      <button
                        key={index}
                        type="button"
                        onClick={() => handleSelectOrganization(org)}
                        className="w-full p-4 text-left border border-gray-200 dark:border-gray-700 rounded-lg hover:border-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all group"
                      >
                        <div className="flex items-center justify-between">
                          <div>
                            <h3 className="font-semibold text-gray-800 dark:text-white">
                              {org.company_name}
                            </h3>
                            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                              {org.organization}
                            </p>
                          </div>
                          <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 group-hover:bg-blue-100 dark:group-hover:bg-blue-800 flex items-center justify-center transition-colors">
                            <Check className="w-4 h-4 text-gray-400 group-hover:text-blue-600" />
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Step 3: Password Input */}
              {step === "login" && (
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <Label htmlFor="password" className="text-gray-700 dark:text-gray-300 font-medium">
                      Password
                    </Label>
                    <p
                      onClick={() => navigate("/forgot-password")}
                      className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline cursor-pointer transition-colors"
                    >
                      Forgot Password?
                    </p>
                  </div>
                  <div className="relative">
                    <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                    <Input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      className="pl-10 pr-12 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400 transition-colors"
                      {...register("password", { required: true })}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="absolute right-3 top-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
                    >
                      {showPassword ? (
                        <EyeOff size={20} className="stroke-current" />
                      ) : (
                        <Eye size={20} className="stroke-current" />
                      )}
                    </button>
                  </div>
                  
                  {/* Show organization info on login screen */}
                  {selectedOrg && (
                    <div className="mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                      <p className="text-xs text-blue-600 dark:text-blue-400">
                        Logging in to: <span className="font-semibold">{selectedOrg.company_name}</span>
                      </p>
                    </div>
                  )}
                </div>
              )}

              <Button
                type="submit"
                className="w-full h-12 mt-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold shadow-lg shadow-blue-500/25 dark:shadow-blue-500/15 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/35 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={loading}
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                    <span className="ml-2">
                      {step === "email" && "Fetching organizations..."}
                      {step === "login" && "Signing in..."}
                    </span>
                  </div>
                ) : (
                  <>
                    <LogIn className="mr-2 h-5 w-5" />
                    {step === "email" && "Continue"}
                    {step === "organizations" && "Select Organization"}
                    {step === "login" && "Sign In"}
                  </>
                )}
              </Button>

              {/* Back buttons */}
              {step === "organizations" && (
                <Button
                  type="button"
                  onClick={handleBackToEmail}
                  variant="outline"
                  className="w-full h-12 mt-2"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to Email
                </Button>
              )}

              {step === "login" && organizations.length > 1 && (
                <Button
                  type="button"
                  onClick={handleBackToOrganizations}
                  variant="outline"
                  className="w-full h-12 mt-2"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to Organizations
                </Button>
              )}

              <Button
                type="button"
                onClick={() => navigate("/")}
                className="w-full h-12 mt-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-semibold shadow-md transition-all duration-300"
              >
                ← Back to Home
              </Button>
            </form>
          </CardContent>

          <CardFooter className="flex justify-center pt-6 border-t border-gray-100 dark:border-gray-700">
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Don't have an account?{" "}
              <Button
                variant="link"
                className="p-0 h-auto font-semibold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                onClick={() => {
                  console.log("Login.tsx: Navigate to register button clicked");
                  navigate("/register")
                }}
              >
                Sign up now
              </Button>
            </p>
          </CardFooter>
        </Card>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400 opacity-75">
            Secure login with end-to-end encryption
          </p>
        </div>
      </div>

      {/* Footer note */}
      <div className="absolute bottom-4 left-0 right-0 text-center">
        <p className="text-xs text-gray-400 dark:text-gray-500">
          Protected by advanced security protocols • © {new Date().getFullYear()}
        </p>
      </div>

      <style>{`
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
      `}</style>
    </div>
  )
}